import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
// import Button from '../common/Button';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { UserCircleIcon as UserCircleIconSolid } from '@heroicons/react/24/solid';

function Header({ toggleSidebar }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  // const handleLogout = () => {
  //   logout();
  // };

  const goToProfile = () => {
    navigate('/profile');
  };

  return (
    <header className="bg-gradient-to-r from-white via-gray-50 to-indigo-50 p-2 md:p-3 flex justify-between items-center z-30 border-b-2 border-indigo-100 shadow-lg backdrop-blur-lg">
      <div className="flex items-center">
        <button 
          onClick={toggleSidebar} 
          className="md:hidden text-gray-500 hover:text-indigo-600 p-1.5 rounded-xl hover:bg-indigo-50 transition-all duration-200 mr-2 shadow-sm hover:shadow-md"
        >
          <Bars3Icon className="h-5 w-5" />
        </button>
      </div>
      
      <div className="flex items-center space-x-3">
        <div className="relative hidden md:block">
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-1 border border-blue-200 shadow-sm">
            <input
              type="text"
              placeholder="Search now..."
              className="w-60 px-3 py-2 rounded-lg border border-blue-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-gray-700 text-sm bg-white transition-all duration-200 shadow-sm hover:shadow-md"
            />
            <svg className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>

        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-1.5 border border-green-200 shadow-sm">
          <button 
            onClick={goToProfile} 
            className="flex items-center space-x-2 p-1.5 rounded-xl hover:bg-gradient-to-r hover:from-green-100 hover:to-emerald-100 transition-all duration-200 group hover:shadow-md hover:transform hover:scale-[1.02]"
          >
            <UserCircleIconSolid className="h-7 w-7 text-gray-500 group-hover:text-green-600 transition-all duration-200 group-hover:scale-110" />
            {user && (
              <div className="hidden sm:block">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                  <span className="text-gray-800 text-sm font-semibold">
                    {user.firstName || user.username}
                  </span>
                </div>
              </div>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
